import { U21Alert, U21Spacer } from 'app/shared/u21-ui/components';

import { evaluateAndEnrich } from 'app/modules/rules/helpers';
import { Operand } from 'app/modules/detectionModels/components/ConditionBreakdown/Operand';
import { RuleConditionTooltips } from 'app/modules/detectionModels/constants';
import { ConditionBreakdownProps } from 'app/modules/detectionModels/components/ConditionBreakdown/ConditionBreakdownModal';

export const ConditionBreakdown = ({
  ruleCondition,
  alertHits,
  alertHitIndex,
}: ConditionBreakdownProps) => {
  if (alertHitIndex < 0) {
    return null;
  }

  const snapshot = alertHits[alertHitIndex]?.variable_snapshots || {};
  const hasSnapshot = alertHits && Object.keys(snapshot).length > 0;
  const enrichedRuleCondition = ruleCondition
    ? evaluateAndEnrich(
        ruleCondition,
        snapshot,
        alertHits[alertHitIndex]?.window_end,
      )
    : undefined;

  const renderAlert = (message: string) => (
    <U21Alert color="warning">{message}</U21Alert>
  );

  const getBodyContent = () => {
    // No snapshot
    if (!hasSnapshot) {
      return renderAlert(RuleConditionTooltips.RULE_CONDITIONS_NOT_AVAILABLE);
    }

    // Error enriching condition
    if (!enrichedRuleCondition) {
      return renderAlert('Error evaluating rule condition.');
    }

    return enrichedRuleCondition.operands.map((operand, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <U21Spacer key={index}>
        <Operand
          op={operand}
          group={enrichedRuleCondition.operator}
          isFirst={index === 0}
        />
        <div />
      </U21Spacer>
    ));
  };

  return <div>{getBodyContent()}</div>;
};
